@if (viewModel$ | async; as vm) {
  <form [formGroup]="locationForm" (ngSubmit)="updateHomeLocation(vm.homeId, vm.selectedCoordinates)" class="is-fullheight">
    <lay-panel class="flex-column">
      <lay-panel-content>
        <lay-panel-block size="large" class="is-borderless has-border-bottom">
          <div class="is-block is-fullwidth">
            <app-input-label>{{ 'common-settings.__ENTER_ADDRESS' | LANG }}</app-input-label>
            <app-input-text
              formControlName="address"
              updateOn="change"
              [placeholder]="'common-settings.__ATTRIBUTE_ADDRESS' | LANG">
            </app-input-text>
          </div>
        </lay-panel-block>

        @if (suggestedPlaces(); as suggestedPlaces) {
          <div class="is-relative">
            <div class="dropdown-wrapper">
              @for(place of suggestedPlaces; track $index) {
                <lay-panel-block class="dropdown-line" (click)="updatePosition(place.coordinates); closeDropdown()">
                  <app-text [text]="place.address" />
                </lay-panel-block>
              }
            </div>
          </div>
        }

        <app-location-map
          [coordinates]="vm.selectedCoordinates"
          [altitude]="vm.homeAltitude"
          [showAltitude]="!(isFormSubmittable$ | async)"
          (changePosition)="updatePosition($event)"
          (click)="closeDropdown()"
        />
      </lay-panel-content>
      @if (isFormSubmittable$ | async) {
        <lay-panel-footer>
          <lay-button class="is-flex-button">
            <button
            type="submit"
            class="is-primary-button"
            [ngClass]="{'is-loading': confirmLoader.loading$ | async}"
            >
              <app-text [text]="'common-app.__CONFIRM' | LANG"></app-text>
            </button>
          </lay-button>
        </lay-panel-footer>
      }
    </lay-panel>
  </form>
}
